
module Meevo {

  export interface IMeevoSideMenu extends ng.material.ISidenavService {

  }

  export class MeevoSideMenu implements angular.IDirective {
    restrict = "E";

    // Render nothing until the business-info settings have loaded, then choose the menu template
    // exactly once. This avoids two problems:
    //  1) Picking the template at compile time locks in the legacy menu because APP_BUSINFOSETTINGS
    //     is not yet populated when <meevo-side-menu> first compiles (right after authentication).
    //  2) Reactively swapping templates would re-create the MenuController and re-register the
    //     md-sidenav instances ('left' / 'leftSecond'), which crashes ($mdSidenav(...).then).
    // Choosing once, after the setting is known, gives the correct look with a single registration.
    // The legacy menu.html is left completely untouched.
    template = '<ng-include ng-if="meevoMenuTemplateUrl" src="meevoMenuTemplateUrl"></ng-include>';

    constructor(private appSettings: Meevo.Components.Common.IAppSettings) {
    }

    link = (scope: any) => {
      const unwatch = scope.$watch(
        () => !!(this.appSettings.APP_BUSINFOSETTINGS
          && this.appSettings.APP_BUSINFOSETTINGS.generalSettings),
        (settingsLoaded: boolean) => {
          if (!settingsLoaded) {
            return;
          }

          const enhanced = !!this.appSettings.APP_BUSINFOSETTINGS.generalSettings.enableEnhancedGlobalNavigation;

          scope.meevoMenuTemplateUrl = enhanced
            ? 'app/components/menu/menuEnhanced.html'
            : 'app/components/menu/menu.html';

          // Lock in the choice so the MenuController / md-sidenavs are only ever created once.
          unwatch();
        });
    };


    static factory(): angular.IDirectiveFactory {
      let directive = (appSettings: Meevo.Components.Common.IAppSettings) => {
        return new MeevoSideMenu(appSettings);
      };

      directive.$inject = ['meevo.AppSettings'];

      return directive;
    }
  }

  angular.module("meevo")
    .directive("meevoSideMenu", MeevoSideMenu.factory());
}